import type { Language } from '@/i18n';
import { apiClient } from '@/lib/api-client';
import type { User } from '@/types/api';

export const authApi = {
  async login(email: string, password: string) {
    const { data } = await apiClient.post<{ token: string; user: User }>('/auth/login', {
      email,
      password,
    });
    return data;
  },
  /** Support mode: a token for one clinic's settings and users (platform administrators). */
  async enterClinic(clinicId: string) {
    const { data } = await apiClient.post<{ token: string; user: User }>(
      `/platform/clinics/${clinicId}/support`
    );
    return data;
  },
  async me() {
    const { data } = await apiClient.get<User>('/auth/me');
    return data;
  },
  /** Save the signed-in user's own profile; a new password needs the current one. */
  async updateMe(
    patch: Partial<{
      locale: Language;
      name: string;
      licenseNumber: string | null;
      password: string;
      currentPassword: string;
    }>
  ) {
    const { data } = await apiClient.patch<User>('/auth/me', patch);
    return data;
  },
};
